exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comment-section{\n\t\t    border-left: 1px solid #E8E9EB;\n    \t\tbackground-color: #F2F3F5;\n}\n", ""]);

// exports
